"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentsRoutingKey = void 0;
var PaymentsRoutingKey;
(function (PaymentsRoutingKey) {
    PaymentsRoutingKey["CareSubscriptionTrueUp"] = "payments_CareSubscriptionTrueUp";
    PaymentsRoutingKey["CheckForMissingEnrollmentInvoices"] = "payments_CheckForMissingEnrollmentInvoices";
    PaymentsRoutingKey["IssueDailyPayout"] = "payments_IssueDailyPayout";
    PaymentsRoutingKey["PaymentReceived"] = "payments_PaymentReceived";
    PaymentsRoutingKey["PerformBitwerxHealthcheck"] = "payments_PerformBitwerxHealthcheck";
    PaymentsRoutingKey["PerformCarePlanEnrollmentUpgrade"] = "payments_PerformCarePlanEnrollmentUpgrade";
    PaymentsRoutingKey["PerformCareStripeSubscriptionShutdown"] = "payments_PerformCareStripeSubscriptionShutdown";
    PaymentsRoutingKey["PerformCareStripeSubscriptionSync"] = "payments_PerformCareStripeSubscriptionSync";
    PaymentsRoutingKey["PerformTerminalHealthcheck"] = "payments_PerformTerminalHealthcheck";
    PaymentsRoutingKey["ProcessPastDueInvoices"] = "payments_ProcessPastDueInvoices";
    PaymentsRoutingKey["ProcessStripeWebhook"] = "payments_ProcessStripeWebhook";
    PaymentsRoutingKey["ResendReceipt"] = "payments_ResendReceipt";
    PaymentsRoutingKey["RetryCareAccountCreditWriteback"] = "payments_RetryCareAccountCreditWriteback";
    PaymentsRoutingKey["RetryCareSubscriptionTrueUp"] = "payments_RetryCareSubscriptionTrueUp";
    PaymentsRoutingKey["RetryFailedCarePayments"] = "payments_RetryFailedCarePayments";
    PaymentsRoutingKey["RetryGetInvoiceNumberAfterWriteback"] = "payments_RetryGetInvoiceNumberAfterWriteback";
    PaymentsRoutingKey["RetryWriteback"] = "payments_RetryWriteback";
    PaymentsRoutingKey["SendItemizedReceipt"] = "payments_SendItemizedReceipt";
    PaymentsRoutingKey["SyncStripeCustomerInfo"] = "payments_SyncStripeCustomerInfo";
})(PaymentsRoutingKey = exports.PaymentsRoutingKey || (exports.PaymentsRoutingKey = {}));
//# sourceMappingURL=types.js.map